import get from 'lodash/get';
import { getCookie } from '@utils/cookie';
import { inBrowser } from '@utils/index';
import { parseQuery, appendParams, getUrlParam } from '@utils/url';
import appConfig from '../../../appConfig';
import Weblog, { PVOptions } from '@ks/weblogger';
import { ClickOptions } from '@ks/weblogger/dist/types/config/types';

const backupStartTime = new Date().getTime();
let weblog: Weblog | null = null;
if (inBrowser) {
    const WeblogClass = require('@ks/weblogger').Weblog;
    weblog = new WeblogClass(
        { ...appConfig.weblogConfig.config },
        {
            user_id: getCookie('ud'),
            ...appConfig.weblogConfig.product,
        }
    );
}

export const logger = weblog;
// 劫持发送方法，打印日志方便调试
// if (process.env.NODE_ENV === 'development') {
//     const { send } = weblog.logger;
//     weblog.logger.send = (data, immediate, async) => {
//         console.log('[WebLogger]', 'immediate', immediate, 'async', async, data.event_package || data);
//         send.call(weblog.logger, data, immediate, async);
//     };
// }

const activityIdSourceCache = {
    source: getUrlParam('source') || 'unknown',
};

function generatePageParam(pageParam) {
    let queryParam = '?';
    for (const paramKey in pageParam) {
        // eslint-disable-next-line no-prototype-builtins
        if (pageParam.hasOwnProperty(paramKey) && pageParam[paramKey]) {
            const paramValue = pageParam[paramKey];
            queryParam += `${paramKey}=${paramValue}&`;
        }
    }
    return queryParam;
}

export const getContentPackage = content => {
    const activityId = content?.activityId || '';
    let source = content?.source || '';
    const { ...otherContent } = content;
    if (!source) {
        source = activityIdSourceCache?.source;
    }
    return {
        business_package: {
            business_line: '商家平台',
            custom: {
                activity_id: activityId,
                source: source,
                ...otherContent,
            },
        },
    };
};

export const pageShowLog = (config?: PVOptions) => {
    inBrowser && weblog && weblog.sendImmediately('PV', config || {});
};

export const showLog = (elementPackageAction, elementPackageParam, contentPackage) => {
    inBrowser &&
        weblog &&
        weblog.sendImmediately(
            'SHOW',
            elementPackageAction,
            elementPackageParam,
            JSON.stringify(getContentPackage(contentPackage))
        );
};

export const clickLog = (
    elementPackageAction: ClickOptions['action'],
    elementPackageParam: ClickOptions['params'],
    additionalOptions: Partial<ClickOptions> = {}
) => {
    const options: ClickOptions = {
        action: elementPackageAction,
        params: elementPackageParam,
        ...additionalOptions,
    };
    inBrowser && weblog && weblog.sendImmediately('CLICK', options);
};

export const updateCurrentUrlPackage = (urlPackagePage, urlPackageParams) => {
    if (!urlPackagePage) {
        return;
    }
    const param = generatePageParam(urlPackageParams);
    const url = `${urlPackagePage}${param}`;
    inBrowser && weblog && weblog.updateCurrentUrlPackage(url);
};

function stringify(param) {
    if (typeof param === 'string') {
        return param;
    }
    return JSON.stringify(param);
}

// 给url加上page信息
export const sendPv = function (page, contentPackage = {}, params = {}, type = 'enter') {
    if (inBrowser) {
        const { hash } = window.location;
        let { search } = window.location;
        if (hash.split('?')[1]) {
            search += '&' + hash.split('?')[1];
        }
        const urlParams = parseQuery(search);

        const url = appendParams(window.location.href, {
            ...urlParams,
            // channel_id: xxx,
        });
        weblog && weblog.updateCurrentUrlPackage(url);
        weblog &&
            weblog.sendImmediately('PV', {
                type,
                page,
                params,
                contentPackage: stringify(contentPackage),
                beginTime: get(window, 'performance.timing.navigationStart', backupStartTime),
            } as PVOptions);
    }
};

export const sendClick = function (taskOptions) {
    if (inBrowser && weblog) {
        weblog.sendImmediately('CLICK', taskOptions);
    }
};

export const sendShow = function (showOptions) {
    if (inBrowser && weblog) {
        weblog.collect('SHOW', showOptions);
    }
};

export function sendFmp() {
    inBrowser && process.env.NODE_ENV === 'production' && (weblog as any).plugins.radar.fmp(new Date().getTime());
}

export function setDimensions(dimensionOptions = {}) {
    if (inBrowser && weblog) {
        Object.keys(dimensionOptions).forEach(key => {
            dimensionOptions[key] = stringify(dimensionOptions[key]);
        });
        weblog.plugins.radar.setDimensions(dimensionOptions);
    }
}

export function sendSSRFmp() {
    // 不可用，每个页面的fmp都是要区分的，不能都用c_dimension2
    if (inBrowser && weblog) {
        weblog.plugins.radar.setDimensions({
            c_dimension2: String(new Date().getTime() - performance.timing.navigationStart),
        });
    }
}

export const sendCustomActionStart = (name: string, params?: { [key: string]: any }) => {
    // BUG 记得恢复
    // if (process.env.VUE_APP_NODE_ENV !== 'production') {
    //     // 非线上不上报
    //     return;
    // }
    if (weblog && weblog.plugins && weblog.plugins.radar && weblog.plugins.radar.action) {
        weblog.plugins.radar.action.start({ name, extra_info: params });
    }
};

export const sendCustomActionEnd = (name: string, params?: { [key: string]: any }, successful?: boolean) => {
    // BUG 记得恢复
    // if (process.env.VUE_APP_NODE_ENV !== 'production') {
    //     // 非线上不上报
    //     return;
    // }
    if (weblog && weblog.plugins && weblog.plugins.radar && weblog.plugins.radar.action) {
        weblog.plugins.radar.action.end({ name, extra_info: params, result_type: successful });
    }
};

// 0506新增自定义埋点事件
export function sendCustomEvent(value, key) {
    // 不可用，每个页面的fmp都是要区分的，不能都用c_dimension2
    if (inBrowser && weblog) {
        weblog.sendImmediately('CUSTOM', {
            key: key || 'CLICK_EVENT',
            value: value || {},
        });
    }
}

export const customEvent = (name: string, params: any) => {
    if (weblog?.plugins?.radar) {
        weblog?.plugins?.radar.event({
            ...params,
            name: name,
        });
    }
};

export default {
    sendPv,
    sendClick,
    sendShow,
    sendFmp,
    updateCurrentUrlPackage,
    setDimensions,
    sendSSRFmp,
    pageShowLog,
    showLog,
    clickLog,
    sendCustomActionStart,
    sendCustomActionEnd,
    sendCustomEvent,
    customEvent,
};
